import trefleMineurImg from "../assets/trefle_mineur.png";
import trefleMajeurImg from "../assets/trefle_majeur.png";
import { REWARD_WHEEL_TYPES } from "./rewardWheel";

export const CLOVER_POTION_IDS = {
  MINEUR: "trefle-mineur",
  MAJEUR: "trefle-majeur",
};

export const CLOVER_POTIONS = [
  {
    id: CLOVER_POTION_IDS.MINEUR,
    name: "Potion de trèfles (mineure)",
    image: trefleMineurImg,
    themeClass: "potion-card--clover potion-card--clover-mineur",
    themeColor: "#FFFFFF",
    starsColors: ["#B8F04A", "#4CAF50"],
    starsAnimationDelay: 0,
    wheelType: REWARD_WHEEL_TYPES.ENCOURAGEMENT,
    wheelTitle: "Roue d'encouragement",
    description:
      "50 % de chances pour un score de 10 ou 11 sans perte de maîtrise. Permet de tourner la roue d'encouragement.",
  },
  {
    id: CLOVER_POTION_IDS.MAJEUR,
    name: "Potion de trèfles (majeure)",
    image: trefleMajeurImg,
    themeClass: "potion-card--clover potion-card--clover-majeur",
    themeColor: "#FFFFFF",
    starsColors: ["#7CFF6B", "#2E9B52"],
    starsAnimationDelay: 0,
    wheelType: REWARD_WHEEL_TYPES.FELICITATION,
    wheelTitle: "Roue de félicitation",
    description:
      "Obtenue avec un 15/15 sans perte de maîtrise. Permet de tourner la roue de félicitation.",
  },
];

const cloverPotionsById = new Map(CLOVER_POTIONS.map((potion) => [potion.id, potion]));

export function getCloverPotionById(potionId) {
  return cloverPotionsById.get(potionId) ?? null;
}

export function getCloverTierLabel(potionId) {
  if (potionId === CLOVER_POTION_IDS.MAJEUR) return "majeure";
  if (potionId === CLOVER_POTION_IDS.MINEUR) return "mineure";
  return null;
}

export function getWheelTypeForCloverPotion(potionId) {
  return getCloverPotionById(potionId)?.wheelType ?? null;
}
